import { API_BASE_URL as BASE_URL } from './apiConfig';

const API_BASE_URL = `${BASE_URL}/auth`;

export interface RegisterRequest {
  phone_number: string;
  email: string;
  sessionId: string;
  person_name?: string;
  company_name: string;
  company_address?: string;
  company_product_service?: string;
  gstn_number?: string;
}

export interface SendOTPRequest {
  email: string;
}

export interface VerifyOTPRequest {
  sessionId: string;
  otp: string;
  email: string;
}

export interface SelectAccountRequest {
  sessionId: string;
  email: string;
  userId: number | string;
}

export interface LoginAccount {
  id: number;
  company_name: string;
  person_name?: string;
  role: string;
}

export interface SendRegistrationOTPRequest {
  email: string;
  person_name?: string;
}

export interface VerifyRegistrationOTPRequest {
  sessionId: string;
  otp: string;
  email: string;
}

export interface AuthResponse {
  success: boolean;
  message: string;
  data?: any;
  token?: string;
  user?: any;
  sessionId?: string;
  maskedEmail?: string;
  requiresAccountSelection?: boolean;
  accounts?: LoginAccount[];
}

class AuthService {
  private async makeRequest(endpoint: string, data: any): Promise<AuthResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      
      if (!response.ok) {
        // Throw an error with the server's message
        const errorMessage = result.message || `HTTP error! status: ${response.status}`;
        console.error(`Auth API Error (${endpoint}):`, errorMessage);
        throw new Error(errorMessage);
      }

      return result;
    } catch (error: any) {
      console.error(`Auth API Error (${endpoint}):`, error);
      // Re-throw the error to be caught by the caller
      throw error instanceof Error ? error : new Error(error?.message || 'Request failed');
    }
  }

  async register(data: RegisterRequest): Promise<AuthResponse> {
    return this.makeRequest('/signup', data);
  }

  async sendRegistrationOTP(data: SendRegistrationOTPRequest): Promise<AuthResponse> {
    return this.makeRequest('/send-registration-otp', data);
  }

  async verifyRegistrationOTP(data: VerifyRegistrationOTPRequest): Promise<AuthResponse> {
    return this.makeRequest('/verify-registration-otp', data);
  }

  async sendOTP(data: SendOTPRequest): Promise<AuthResponse> {
    return this.makeRequest('/send-otp', data);
  }

  async verifyOTP(data: VerifyOTPRequest): Promise<AuthResponse> {
    return this.makeRequest('/verify-otp', data);
  }

  async selectAccount(data: SelectAccountRequest): Promise<AuthResponse> {
    return this.makeRequest('/select-account', data);
  }
}

export default new AuthService();


